module.exports = __webpack_public_path__ + "static/img/homeleft11.bb1ed89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeleft11.png
// module id = 2oqg
// module chunks = 13